import * as httpx from "httpx"
import * as videos from "."
import { VideoEvent, VideoSearchResponseItem } from "brandguard/brandguard.video_pb"

export const agree = (
	item: VideoSearchResponseItem & { event: VideoEvent },
	...options: httpx.option[]
): Promise<VideoSearchResponseItem> => {
	return videos.uploads.review(item.event.id, item.event.brand_id, ...options)
}

export const disagree = (
	item: VideoSearchResponseItem & { event: VideoEvent },
	...options: httpx.option[]
): Promise<VideoSearchResponseItem> => {
	return videos.uploads.review(item.event.id, item.event.brand_id, ...options)
}
